<del-shared-menu-sidebar [isFriends]="true"></del-shared-menu-sidebar>
